<template>  
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -40px">
      <v-container grid-list-xl fluid>
        <v-layout row>
          <template v-for="(item,i) in items">
            <v-flex xs12 md4 :key="i">
              <v-card
                class="mx-auto pt-4"          
                outlined
              >
                <v-list>                  
                  <v-list-tile>
                    <v-list-tile-content class="mr-4">
                      <!--<div class="headline my-4">Survey</div>-->
                      <v-list-tile-title>{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}. {{item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.description}}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-avatar
                      tile
                      size="80"
                      :color="item.color"
                    ><v-icon large class="white--text">assignment</v-icon></v-list-tile-avatar>
                  </v-list-tile>
                </v-list>
                <v-card-text>
                  <v-chip :to="{name:'survey/respon', query:{jilid_id:item.id}}" :color="item.color" dark><v-icon left>person</v-icon>{{item.counting.yours | currency}} yours</v-chip> &nbsp;
                  <v-chip><v-icon left>person</v-icon> {{item.counting.all | currency}} all</v-chip>
                  <template v-for="(widget, i) in widgets">
                    <v-chip :key="i" class="ml-2" :color="widget.color" dark @click="openDialog(item, widget)"><v-icon left>extension</v-icon>{{widget.name}}</v-chip>              
                  </template>              
                </v-card-text>            

                <v-card-actions>
                  <v-btn large text flat color="green" :to="{name:'tes/survey/respon/form', query:{jilid_id:item.id}}"><v-icon left>add</v-icon> New Respon</v-btn>
                  <v-btn large text flat color="orange" :to="{name:'tes/survey/respon', query:{jilid_id:item.id}}">list</v-btn>
                  <v-spacer/>              
                </v-card-actions>

              </v-card>
            </v-flex>
          </template>
          <template v-if="loading">
            <v-flex xs12 md4 v-for="(i) in 1" :key="i">
              <v-progress-circular
                :size="70"
                :width="7"
                color="purple"
                indeterminate
              ></v-progress-circular>
            </v-flex>
          </template>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-btn color="blue" v-if="page<totalPages" :loading="loading" dark @click="page = page + 1">Load More</v-btn>        
          </v-flex>
        </v-layout>
        
        <!--<v-card>
          <v-toolbar flat>      
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search"
              single-line
              hide-details        
              @input="search"
              style="max-width:200px"
            ></v-text-field>                 
            <v-spacer/>
            <v-btn fab color="green" dark small absolute right :to="{name:'master/quetionnaire/form'}"><v-icon>add</v-icon></v-btn>                      
          </v-toolbar>
        </v-card>--> 
      </v-container>  
    </div>
  </v-slide-y-transition>    
</template>

<script>
import { debounce } from 'lodash'
import Survey  from '@/apps/admin/models/master/Survey'

export default {
  data () {
    return {
      term : null,     
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,        
      widgets: [
        {id:1, name:'alokasi', color:'cyan'},        
      ],
      option:{
        widget:{},        
      }      
    }
  },
  computed:{
    status(){
      return {0:'inactive',1:'active'};      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    openDialog(item, widget){
      item.dialog = true;
      this.option.widget = widget;
    },

    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        status: 1,
        sort:sortby,
        expand:'counting,quetionnaires',
        outsoal:true
      }
      Survey.jilids(params)
        .then(response => {
          if(Array.isArray(response.data)){
            response.data.forEach(item=>{
              item.dialog =false;
              item.loadingDownload = false;
              item.offline = false;                           
            });            
          }
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false                    
        })
    },            
  },  
}
</script>